import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import filter from 'lodash/filter';
import { configuratorChoices, configuratorOptions, configuratorOptionIdSelector } from '../configurator';

export const choiceSelectionsSelector = createSelector(
  (state) => state.selections,
  (selections) => selections
);

export const selectChoiceOptionById = (optionId) => createSelector(
  [choiceSelectionsSelector, configuratorChoices],
  (selections, configChoices) => {
    if (!isEmpty(selections)) {
      const { choiceId = null } = selections[optionId] || {};
      return choiceId ? configChoices[choiceId] : {};
    }
    return {};
  }
);

export const selectDependentChoices = (optionId) => createSelector(
  [choiceSelectionsSelector],
  (selections) => selections?.choices
);

export const currentActiveSkuSelector = createSelector(
  [choiceSelectionsSelector, configuratorOptionIdSelector('OMSID')],
  (selections, omsidOptionId) => {
    return omsidOptionId ? selections[omsidOptionId]?.choiceValue : undefined;
  }
);